export default __webpack_public_path__ + "static/media/yellowStatus_icon.cd2b522b.svg";